import React, { useMemo } from "react";
import {
  AppPage,
  MimaButton,
  MimaDropdown,
  MimaTable,
  MimaText,
  PageLoader,
} from "../../../components";
import constant from "../../../utils/constant";
import { amountFormatter } from "../../../utils/utils";
import { Formik } from "formik";
import { adminStore } from "../../../stores";
import styles from "../../../assets/styles/Competition/Competition.module.scss";
import { downloadXlsx2 } from "../../../utils/download";

const Votes = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  validationSchema,
  onSubmit,
  setCompetition,
  setStage,
  loading,
}) => {
  const competitionsArray = adminStore.competitions;
  const participantsArray = adminStore.participants;

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.votes || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Competition Name",
      Cell: ({ cell }) => {
        const competitionNmae = cell.row.original.competition.name;
        return <span>{competitionNmae}</span>;
      },
    },
    {
      Header: "Competition Stage",
      accessor: "stage",
    },
    {
      Header: "Participant",
      Cell: ({ cell }) => {
        const firstName = cell.row.original.participant.firstname;
        const lastName = cell.row.original.participant.lastname;

        return <span>{`${firstName} ${lastName}`}</span>;
      },
    },
    {
      Header: "Current Votes",
      accessor: "votes",
    },
    {
      Header: "Amount",
      Cell: ({ cell }) => {
        const amount = cell.row.original.amount;
        const currenyCode = cell.row.original.currenyCode;

        return <span>{amountFormatter(currenyCode).format(amount)}</span>;
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const styleClass = `status ${status === "PAID" ? "status__green" : "status__dark__yellow"}`;
        return <span className={styleClass}>{status}</span>;
      },
    },
  ];

  const printData = tableData.map((item) => ({
    Competition: item?.competition.name,
    "Participant Name": `${item?.firstname} ${item?.lastname}` || "",
    "Competition stage": item.competition.stage,
    "Current Votes": item.votes,
    Amount: amountFormatter(item.currenyCode).format(item.amount),
  }));
  return (
    <AppPage pageTitle="Votes">
      <div>
        <Formik
          initialValues={{
            competition: "",
            stage: "",
            participant: "",
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            values,
            errors,
            touched,
          }) => (
            <>
              <div className={styles.votesPage}>
                <MimaText variant="bodyBold" mb={2}>
                  Filter Votes Table
                </MimaText>
                <MimaDropdown
                  labelTitle="Competitions"
                  name="competition"
                  id="competition"
                  value={values.competition}
                  placeholder="Select Competition"
                  currentValue={values.competition}
                  onChange={(data) => {
                    setFieldValue("competition", data);
                    setCompetition(data);
                  }}
                  touched={touched.competition}
                  error={errors.competition}
                  data={competitionsArray}
                  width={30}
                />

                <MimaDropdown
                  labelTitle="Competition stage"
                  name="stage"
                  value={values.stage}
                  placeholder="Select Competition stage"
                  id="stage"
                  currentValue={values.stage}
                  onChange={(data) => {
                    setFieldValue("stage", data.key);
                    setStage(data.key);
                  }}
                  data={[
                    { value: "ONE", key: "ONE" },
                    { value: "TWO", key: "TWO" },
                  ]}
                  width={30}
                  touched={touched.stage}
                  error={errors.stage}
                />

                <MimaDropdown
                  labelTitle="Participant"
                  name="participant"
                  id="participant"
                  value={values.participant}
                  placeholder="Select Participants"
                  currentValue={values.participant}
                  onChange={(data) => {
                    setFieldValue("participant", data);
                  }}
                  data={participantsArray}
                  touched={touched.participant}
                  error={errors.participant}
                  width={30}
                />
                <MimaButton
                  title="Filter"
                  width={30}
                  buttonColor="var(--color-dark-4)"
                  onClick={() => {
                    handleSubmit();
                  }}
                  loading={loading}
                />
              </div>
            </>
          )}
        </Formik>

        {isLoading ? (
          <PageLoader title="while we load your information" />
        ) : (
          <div>
            <MimaButton
              title={`Download Report`}
              mt={2}
              onClick={() => {
                downloadXlsx2(printData);
              }}
            />
            <MimaTable
              tableData={tableData}
              tableColumns={tableColumns}
              searchPlaceholder="Search Votes"
              searchVariant="wide"
              totalItems={data?.data?.totalCounts}
              onLimitChange={onLimitChange}
              isLoading={isLoading}
              isFetching={isFetching}
              limit={limit}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setSearchQuery={setSearchQuery}
            />
          </div>
        )}
      </div>
    </AppPage>
  );
};
export default Votes;
